(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sale-banner]').forEach(function (root) {
      var endTime = new Date(root.getAttribute('data-end')).getTime();
      var timerEl = root.querySelector('[data-sale-banner-timer]');
      var headlineEl = root.querySelector('[data-sale-banner-headline]');
      var subtextEl = root.querySelector('[data-sale-banner-subtext]');
      var endedEl = root.querySelector('[data-sale-banner-ended]');
      var daysEl = root.querySelector('[data-sale-banner-days]');
      var hoursEl = root.querySelector('[data-sale-banner-hours]');
      var minutesEl = root.querySelector('[data-sale-banner-minutes]');
      var secondsEl = root.querySelector('[data-sale-banner-seconds]');

      if (isNaN(endTime)) {
        return;
      }

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        var remaining = endTime - Date.now();

        if (remaining <= 0) {
          timerEl.hidden = true;
          headlineEl.hidden = true;
          subtextEl.hidden = true;
          endedEl.hidden = false;
          clearInterval(interval);
          return;
        }

        var days = Math.floor(remaining / (1000 * 60 * 60 * 24));
        var hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
        var minutes = Math.floor((remaining / (1000 * 60)) % 60);
        var seconds = Math.floor((remaining / 1000) % 60);

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      tick();
      var interval = setInterval(tick, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
